import React from 'react'

import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'

import NavTabs from 'ui/components/NavTabs'
import { ADMIN_PATHS, CONFIG_PATHS, MASTER_PATHS } from 'utils/constants/routerPaths'

export default function ({ currentPath }) {
  return (
    <React.Fragment>
      <NavTabs
        title="Conta"
        icon={<SettingsOutlinedIcon fontSize="small" />}
        paths={CONFIG_PATHS}
        currentPath={currentPath}
      />

      <NavTabs
        title="Organização"
        icon={<SettingsOutlinedIcon fontSize="small" />}
        paths={ADMIN_PATHS}
        currentPath={currentPath}
      />

      <NavTabs
        title="Gerencia"
        icon={<SettingsOutlinedIcon fontSize="small" />}
        paths={MASTER_PATHS}
        currentPath={currentPath}
      />
    </React.Fragment>
  )
}
